import { css } from 'styled-components';
export const navDropdownShadow = css `
  box-shadow: 0 5px 30px rgba(0, 0, 0, 0.1);
`;
export const screenReaderOnly = css `
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;
export const focusOutline = css `
  outline: none;
  position: relative;

  &:before {
    content: ' ';
    display: block;
    position: absolute;
    pointer-events: none;
    inset: 0;
    outline-style: none;
    outline-color: ${o => o.theme.color.effect.focus.outline.on.background};
    outline-offset: ${o => o.focusOutlineOffset ? `${o.focusOutlineOffset}px` : `calc(${o.theme.spacing(1)} / 2)`};
    outline-width: calc(${o => o.theme.spacing(1)} / 2);
    z-index: ${o => o.theme.zIndex.popovers};
  }

  &:focus-visible {
    &:before {
      outline-style: solid;
    }
  }
`;
export const focusOutlineInset = css `
  ${focusOutline};

  &:before {
    outline-offset: ${o => o.focusOutlineOffset ? `-${o.focusOutlineOffset}px` : `-${o.theme.spacing(1)}`};
  }
`;
export const focusOutlineWithin = css `
  ${focusOutline};

  &:has(:focus-visible) {
    &:before {
      outline-style: solid;
    }
  }
`;
//# sourceMappingURL=index.js.map